<template>
  <div
    class="teaser-content cell"
  >
    <div
      v-if="groupitem.link && groupitem.link.url"
      class="title"
    >
      <generic-link :href="groupitem.link.url" v-if="!groupitem.link.title">
        <h3 v-if="groupitem.title" class="group-title">
          {{ groupitem.title }}
        </h3>
      </generic-link>
      <h3 v-else-if="groupitem.title" class="group-title">
        {{ groupitem.title }}
      </h3>
    </div>

    <div
      v-else
      class="title"
    >
      <h3>{{ groupitem.title }}</h3>
    </div>

    <div
      class="description"
      v-html="groupitem.body"
    />
    <generic-link
      v-if="groupitem.link && groupitem.link.url && groupitem.link.title"
      :href="groupitem.link.url"
    >
      {{ groupitem.link.title }}
    </generic-link>
  </div>
</template>

<script>

export default {
  name: 'content-group-details',
  props: {
    groupitem: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.group-title {
  color: var(--main-link-color);
}

@include media-breakpoint-up(md) {
  .portrait {
    .teaser-content {
      width: 75%;
    }
  }

  .landscape {
    .teaser-content {
      width: 60%;
    }
  }
}

//cell structure
.cell:nth-child(1).teaser-content {
  margin-top: 0em;
  width: 100%;
  padding: 0em;
}

.cell:nth-child(2),
.cell:not(:nth-child(1)) {
  padding-left: 0em;
  @include media-breakpoint-up(md) {
    padding-left: 2em;
  }
}
.right {
  .cell:nth-child(2),
  .cell:not(:nth-child(1)) {
    padding-left: 0em;
    @include media-breakpoint-up(md) {
      padding-right: 2em;
    }
  }
}
</style>
